import { render, staticRenderFns } from "./PriceTerms.vue?vue&type=template&id=4b749a9d&scoped=true"
import script from "./PriceTerms.vue?vue&type=script&lang=js"
export * from "./PriceTerms.vue?vue&type=script&lang=js"
import style0 from "./PriceTerms.vue?vue&type=style&index=0&id=4b749a9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b749a9d",
  null
  
)

export default component.exports